import { render } from "./LicenseSettings.vue?vue&type=template&id=22d7ca18&scoped=true"
import script from "./LicenseSettings.vue?vue&type=script&lang=js"
export * from "./LicenseSettings.vue?vue&type=script&lang=js"

import "./LicenseSettings.vue?vue&type=style&index=0&id=22d7ca18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d7ca18"]])

export default __exports__